namespace TabAurous.OMS {
    export interface PriceListDetailsForm {
        PriceListId: Serenity.IntegerEditor;
        ProductId: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        FromWt: Serenity.DecimalEditor;
        ToWt: Serenity.DecimalEditor;
        FromDate: Serenity.DateEditor;
        ToDate: Serenity.DateEditor;
        PurStdRate: Serenity.DecimalEditor;
        SaleStdRate: Serenity.DecimalEditor;
        MarkUp: Serenity.DecimalEditor;
        Amount: Serenity.DecimalEditor;
    }

    export class PriceListDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.PriceListDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PriceListDetailsForm.init)  {
                PriceListDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.DateEditor;

                Q.initFormType(PriceListDetailsForm, [
                    'PriceListId', w0,
                    'ProductId', w1,
                    'AttributeId', w1,
                    'FromWt', w2,
                    'ToWt', w2,
                    'FromDate', w3,
                    'ToDate', w3,
                    'PurStdRate', w2,
                    'SaleStdRate', w2,
                    'MarkUp', w2,
                    'Amount', w2
                ]);
            }
        }
    }
}
